import { DataPeriods } from '@utils/dataPeriods';

export enum SurveyStatsStatus {
  Pending = 'pending',
  Completed = 'completed',
}

/** Who the Analytics download names in a survey's Contributor / Verifier columns */
export enum ResponsibilityMode {
  Assigned = 'assigned',
  Answered = 'answered',
}

export interface StatsDownloadOptions {
  responsibility: ResponsibilityMode;
  /** Staff only; the API ignores it for everyone else */
  includeStaff: boolean;
}

export enum UserStatsPermissionView {
  Explicit = 'explicit',
  Permission = 'permission',
}

// Array-based filters for multi-selection dropdowns
export type SurveyStatsFiltersProps = {
  initiatives?: string[];
  years?: string[];
  months?: string[];
  periods?: DataPeriods[];
  surveyStatuses?: SurveyStatsStatus[];
};
